import DropdownSearchPopover from './DropdownSearchPopover'

export default DropdownSearchPopover



// WEBPACK FOOTER //
// ./src/legacy/containers/Popovers/DropdownSearchPopover/index.js